import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const getEffortAssumptions = async (effortId) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/business/efforts/${effortId}/assumptions/`,
      getConfig()
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching success criteria:", error);
    throw error;
  }
};

export const createEffortAssumptions = async (effortId, assumptionData) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/business/efforts/${effortId}/assumptions/`,
      assumptionData,
      getConfig()
    );
    return response.data.data;
  } catch (error) {
    console.error("Error creating success criteria:", error);
    throw error;
  }
};

export const updateEffortAssumptions = async (
  effortId,
  criteriaId,
  assumptionData
) => {
  try {
    const response = await axios.put(
      `${baseUrl}/api/business/efforts/${effortId}/assumptions/${criteriaId}/`,
      assumptionData,
      getConfig()
    );
    return response.data.data;
  } catch (error) {
    console.error("Error updating success criteria:", error);
    throw error;
  }
};

export const deleteEffortAssumptions = async (effortId, criteriaId) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/api/business/efforts/${effortId}/assumptions/${criteriaId}/`,
      getConfig()
    );
    return response.status === 204;
  } catch (error) {
    console.error("Error deleting success criteria:", error);
    throw error;
  }
};
